import { HttpClient, HttpParams } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Page } from "@models/page";
import { UserInfo } from "@models/user";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import {
  FollowingStatusResponse,
  FollowResponse,
  UnfollowResponse,
} from "./types/relationship.type";

@Injectable({
  providedIn: "root",
})
export class RelationshipsService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.API_BACKEND}/relationships`;

  getFollowing(page = 1, perPage = 10): Observable<Page<UserInfo>> {
    const params = new HttpParams()
      .set("page", page)
      .set("per_page", perPage);
    return this.http.get<Page<UserInfo>>(this.baseUrl, { params });
  }

  isFollowing(followedId: number): Observable<FollowingStatusResponse> {
    return this.http.get<FollowingStatusResponse>(
      `${this.baseUrl}/${followedId}`,
    );
  }

  follow(followedId: number): Observable<FollowResponse> {
    return this.http.post<FollowResponse>(this.baseUrl, {
      followed_id: followedId,
    });
  }

  unfollow(followedId: number): Observable<UnfollowResponse> {
    return this.http.delete<UnfollowResponse>(`${this.baseUrl}/${followedId}`);
  }
}
